import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

export default function DialogClienteAcordoMaterialAlternativo({
  open,
  onClose,
  PaperComponent,
  formAlternativo,
  setFormAlternativo,
  alternativaInput,
  setAlternativaInput,
  materiaisCombo,
  materiaisJaAssociados = [],
  materialLabel,
  carregarMateriaisCombo,
  guardarAlternativo,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperComponent={PaperComponent}>
      <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
        {formAlternativo.id ? "Editar material" : "Inserir material"}
      </DialogTitle>

      <DialogContent>
        <MDBox display="grid" gap={1.5} mt={1}>
          <div>
            <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Material</div>

            <Autocomplete
              size="small"
              options={materiaisCombo.filter(
                (m) =>
                  !materiaisJaAssociados.some(
                    (a) =>
                      String(a.refmaterial) === String(m.ref) &&
                      Number(a.inativo || 0) === 0 &&
                      String(a.id) !== String(formAlternativo.id)
                  )
              )}
              filterOptions={(x) => x}
              inputValue={alternativaInput}
              getOptionLabel={materialLabel}
              value={materiaisCombo.find((m) => m.ref === formAlternativo.refmaterial) || null}
              onInputChange={(_, value, reason) => {
                if (reason === "input") {
                  setAlternativaInput(value);
                  setFormAlternativo((p) => ({ ...p, refmaterial: "" }));
                  carregarMateriaisCombo(value);
                }

                if (reason === "clear") {
                  setAlternativaInput("");
                  setFormAlternativo((p) => ({ ...p, refmaterial: "" }));
                }
              }}
              onChange={(_, value) => {
                setFormAlternativo((p) => ({
                  ...p,
                  refmaterial: value?.ref || "",
                }));
                setAlternativaInput(value ? materialLabel(value) : "");
              }}
              renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
            />
          </div>

          <FormControlLabel
            control={
              <Checkbox
                checked={Number(formAlternativo.inativo || 0) === 1}
                onChange={(e) =>
                  setFormAlternativo((p) => ({
                    ...p,
                    inativo: e.target.checked ? 1 : 0,
                  }))
                }
                size="small"
              />
            }
            label="Inativo"
          />
        </MDBox>
      </DialogContent>

      <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
        <MDButton color="secondary" onClick={onClose}>
          Cancelar
        </MDButton>

        <MDButton color="success" onClick={guardarAlternativo}>
          {formAlternativo.id ? "Atualizar" : "Adicionar"}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
